import { Call, CallRequest } from "types/payload"
import { Action, ActionWithoutPayload, Message } from "types/redux"

// In order to perform an action of type LOGIN_REQUEST
import {
  CALL_CANCEL_ERROR,
  CALL_CANCEL_REQUEST,
  CALL_CANCEL_SUCCESS,
  CALL_ERROR,
  CALL_HANGUP_ERROR,
  CALL_HANGUP_REQUEST,
  CALL_HANGUP_SUCCESS,
  CALL_HAS_CHANGED,
  CALL_REQUEST,
  CALL_SUCCESS,
  GET_CALL,
  JOIN_ROOM_EARLIER,
} from "./constants"

/*
 */
export const getCall = (): ActionWithoutPayload => ({
  type: GET_CALL,
})

export const callHasChanged = (
  response: Call | undefined
): Action<Call | undefined> => ({
  type: CALL_HAS_CHANGED,
  payload: response,
})
/*
 */
export const callRequest = (request: CallRequest): Action<CallRequest> => ({
  type: CALL_REQUEST,
  payload: request,
})

export const callSuccess = (response: Call): Action<Call> => ({
  type: CALL_SUCCESS,
  payload: response,
})

export const callError = (error: string, delay?: number): Action<Message> => ({
  type: CALL_ERROR,
  payload: { type: "error", text: error, delay },
})
/*
 */
export const callHangupRequest = (): ActionWithoutPayload => ({
  type: CALL_HANGUP_REQUEST,
})
export const callHangupSuccess = (): ActionWithoutPayload => ({
  type: CALL_HANGUP_SUCCESS,
})
export const callHangupError = (e: string): Action<Message> => ({
  type: CALL_HANGUP_ERROR,
  payload: { text: e, type: "error" },
})

/*
 */
export const cancelCallRequest = (): ActionWithoutPayload => ({
  type: CALL_CANCEL_REQUEST,
})

export const cancelCallSuccess = ({
  call,
  message,
}: {
  call: Call
  message?: string
}): Action<Message & { call?: Call }> => ({
  type: CALL_CANCEL_SUCCESS,
  payload: { type: "success", text: message, call },
})

export const cancelCallError = (
  message: string
): Action<Message> => ({
  type: CALL_CANCEL_ERROR,
  payload: { type: "error", text: message },
})

export const joinVirtualRoom = (): ActionWithoutPayload => ({
  type: JOIN_ROOM_EARLIER,
})